(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9223],{

/***/ 20276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ SharingLinks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/Global/index.js + 5 modules
var Global = __webpack_require__(25330);
;// CONCATENATED MODULE: ./src/components/SocialSharing/SharingLinks/SharingLinks.jsx




var SharingLinks = function(param) {
    var className = param.className, buttonClassName = param.buttonClassName, _appearance = param.appearance, appearance = _appearance === void 0 ? "dark" : _appearance;
    var socialSharingLinks = (0,Global/* useGlobalState */.j1)().socialSharingLinks;
    var ref = (0,react.useState)(null), currentUrl = ref[0], setCurrentUrl = ref[1];
    (0,react.useEffect)(function() {
        if (true) {
            setCurrentUrl(window.location.href);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: className,
        children: socialSharingLinks.map(function(param) {
            var title = param.title, href = param.href, icon = param.icon;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                as: "a",
                htmlAttributes: {
                    href: "".concat(href).concat(currentUrl),
                    title: title,
                    target: "_blank"
                },
                icon: icon,
                className: buttonClassName,
                appearance: "outlined",
                theme: appearance,
                hover: appearance === "dark" ? "fill" : "reverse"
            }, "".concat(title, "_").concat(href, "_").concat(icon));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SocialSharing/SharingLinks/index.js



/***/ }),

/***/ 19223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget081": function() { return /* binding */ LayoutWidget081; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SocialSharing_SharingLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20276);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91929);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65202);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32667);
/* harmony import */ var _LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32760);
/* harmony import */ var _LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var LayoutWidget081 = function(param) {
    var payload = param.payload;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    var isDesktop = (0,shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_7__/* .useViewMode */ .mJ)().isDesktop;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("l081", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY["LAYOUT-WIDGET"] */ .R["LAYOUT-WIDGET"]);
    var articles = (0,shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_6__/* .useCollectedData */ .M)(instanceId, [
        {
            name: "articles",
            defaultValue: []
        }, 
    ]).articles;
    if (articles.length === 0) {
        return null;
    }
    var _articles = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(articles, 1), article = _articles[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Heading4 */ .k8, {
                                color: "dark",
                                className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
                                children: article.title
                            }),
                            !isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .ImageLite */ .NH, {
                                image: article.previewImage,
                                className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().sharing),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                                        color: "grey",
                                        children: [
                                            t("share"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SocialSharing_SharingLinks__WEBPACK_IMPORTED_MODULE_1__/* .SharingLinks */ ._, {
                                        appearance: "brand",
                                        className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().social),
                                        buttonClassName: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().button)
                                    })
                                ]
                            })
                        ]
                    }),
                    isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_5__/* .ImageLite */ .NH, {
                        image: article.previewImage,
                        className: (_LayoutWidget081_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget081);


/***/ }),

/***/ 32760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget081_wrapper__YungY","content":"LayoutWidget081_content__3bXEG","title":"LayoutWidget081_title__K7NYi","sharing":"LayoutWidget081_sharing__mcOdS","social":"LayoutWidget081_social__fo4TC","button":"LayoutWidget081_button__rTAoZ","image":"LayoutWidget081_image__lLGtK"};

/***/ })

}]);